import React from 'react';
import '../ContactSectionPage/Styles.css';
import { Link } from 'react-router-dom';

const ContactSection = () => {
  return (
    <>
    <div className='divSlider'></div>
    <div className='contactSectionContainer'>
        <div className='contactLogo'>
            <img src='/images/logo/rico-vanhoutteghem-logo-website.png' className='logoContactSection' alt='logo of rico vanhoutteghem' />
            <div className='contactDescription'>
                <p>I believe in patiently designing and handcrafting every jewel, whether it's from my collection or custom made. I hope you enjoy wearing it as much as i did creating it.</p>
            </div>
        </div>
        <div className='contactMenuContainer'>
            <div className='contactMenuTitleContainer'>
                <h2 className='contactMenuTitle'>MENU</h2>
            </div>
            <div className='contactMenuLinks'>
                <Link to='/'>Home</Link>
                <Link to='/category/rings'>Rings</Link>
                <Link to='/category/earrings'>Earrings</Link>
                <Link to='/category/bracelets'>Bracelets</Link>
                <Link to='/category/pendants'>Pendants</Link>
                <Link to='/category/tie-clips-and-cufflinks'>Tie Clips & Cufflinks</Link>
                <Link to='/category/brooches-and-hairpins'>Brooches & Hairpins</Link>
                <Link to='/mystory'>My Story</Link>
                <Link to='/customjewelry'>Custom Jewelry</Link>
                <Link to='/termsandconditions'>Terms & Conditions</Link>
                <Link to='/contact'>Contact</Link>
            </div>
        </div>
        <div className='contactAndSocialMediaSection'>
            <div className='contactSection'>
                <div className='contactSectionTitle'>
                    <h2 className='contactTitle'>CONTACT</h2>
                </div>
                <div className='contactSectionLinks'>
                    <a href='tel:+32499299321'>Phone: +32 (0) 499 29 93 21</a>
                    <a href='mailto:info@ricovanhoutteghem.be'>E-mail: info@ricovanhoutteghem.be</a>
                </div>
            </div>

            <div className='contactSocialMedia'>
                <div className='contactSocialTitleSection'>
                    <h2 className='contactSocialMediaTitle'>SOCIAL MEDIA</h2>
                </div>
                <div className='contactSocialMediaLinks'>
                    <a href='https://www.instagram.com/rico_vanhoutteghem/' target='_blank' rel='noreferrer'>Instagram</a>
                    <a href='https://wa.me/32499299321/' target='_blank' rel='noreferrer'>WhatsApp</a>
                </div>
            </div>
        </div>
    </div>
      
    </>
  )
}

export default ContactSection;
